module.exports = __webpack_public_path__ + "img/u57.ef512590.png";